/* Alberto Bellini, dtc 2026 */
(function(){
  var $=function(s,r){return (r||document).querySelector(s)},
      $$=function(s,r){return [].slice.call((r||document).querySelectorAll(s))};
  function sluit(){
    $$('.la').forEach(function(e){e.classList.remove('aan')});
    var s=$('#sluier'); if(s) s.classList.remove('aan');
    var z=$('#zoekbalk'); if(z) z.classList.remove('aan');
    var m=$('#mega'); if(m) m.classList.remove('open');
    var f=$('#filters'); if(f) f.classList.remove('aan');
    document.body.classList.remove('vast');
  }
  function open(sel){ sluit(); var el=$(sel); if(!el) return; el.classList.add('aan'); var s=$('#sluier'); if(s) s.classList.add('aan'); document.body.classList.add('vast'); }
  var toastT;
  function toon(t){ var el=$('#toast'); if(!el) return; el.textContent=t; el.classList.add('aan'); clearTimeout(toastT); toastT=setTimeout(function(){el.classList.remove('aan')},3000); }
  document.addEventListener('click',function(e){
    var s=e.target.closest('[data-sluit]'); if(s){e.preventDefault();sluit();return;}
    var a=e.target.closest('.acc > button'); if(a){a.parentNode.classList.toggle('open');return;}
    var f=e.target.closest('.filtergroep > button'); if(f){f.parentNode.classList.toggle('open');return;}
  });
  var sl=$('#sluier'); if(sl) sl.onclick=sluit;
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') sluit(); });
  var bg=$('#burger'); if(bg) bg.onclick=function(){open('#mobnav')};
  var zk=$('#zoekknop'); if(zk) zk.onclick=function(){ sluit(); $('#zoekbalk').classList.add('aan'); $('#sluier').classList.add('aan'); document.body.classList.add('vast'); setTimeout(function(){$('#zoekveld').focus()},120); };
  var mega=$('#mega'), megaT;
  function toonMega(naam){
    if(!mega) return;
    $$('[data-mega-inhoud]',mega).forEach(function(el){ el.hidden = el.getAttribute('data-mega-inhoud')!==naam; });
    mega.style.top = document.querySelector('header.kop').getBoundingClientRect().bottom + 'px';
    mega.classList.add('open');
  }
  $$('[data-mega]').forEach(function(b){
    b.addEventListener('mouseenter',function(){ clearTimeout(megaT); toonMega(b.getAttribute('data-mega')); });
    b.addEventListener('focus',function(){ clearTimeout(megaT); toonMega(b.getAttribute('data-mega')); });
    b.addEventListener('click',function(){
      var naam=b.getAttribute('data-mega');
      var actief=mega && mega.classList.contains('open') && $('[data-mega-inhoud="'+naam+'"]',mega) && !$('[data-mega-inhoud="'+naam+'"]',mega).hidden;
      if(actief){ mega.classList.remove('open'); } else { toonMega(naam); }
    });
  });
  var kop=document.querySelector('header.kop');
  if(kop && mega) kop.addEventListener('mouseleave',function(){ megaT=setTimeout(function(){mega.classList.remove('open')},260); });
  if(mega){ mega.addEventListener('mouseenter',function(){clearTimeout(megaT)}); mega.addEventListener('mouseleave',function(){mega.classList.remove('open')}); }

  /* geld en productnamen komen uit bellini2.js, zodat de lade dezelfde
     schrijfwijze gebruikt als de rest van de site (Model | Kleur, € 1.234,00) */
  function geld(c){
    if(window.BELLINI && window.BELLINI.euro) return window.BELLINI.euro(c);
    return '€ ' + (c/100).toFixed(2).replace('.',',');
  }
  function naam(t){
    if(window.BELLINI && window.BELLINI.nette){ var n=window.BELLINI.nette(t); if(n) return n; }
    return t;
  }
  function veilig(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }

  function tekenMand(cart){
    $('#mandtel').textContent = cart.item_count;
    $('#mandtel').classList.toggle('vol', cart.item_count>0);
    var lijf=$('#mandlijf'), voet=$('#mandvoet');
    if(!cart.item_count){
      lijf.innerHTML='<div class="leeg"><span class="d3">Nog niets in je mand</span><a class="btn licht klein" href="/collections/shoes">naar de collectie</a></div>';
      voet.innerHTML=''; return;
    }
    var doel=window.BELLINI.gratisVanaf;
    var rest=Math.max(0, doel - cart.total_price);
    lijf.innerHTML='<div class="verzendbalk"><span class="mini">'+(rest>0?('Nog '+geld(rest)+' tot gratis verzending'):'Gratis verzending, dit pakket komt zonder kosten')+'</span><span class="spoor"><i style="width:'+Math.min(100,cart.total_price/doel*100)+'%"></i></span></div>'
    + cart.items.map(function(it,i){
        var img = it.image ? it.image : '';
        var nm = veilig(naam(it.product_title));
        return '<div class="regel"><a href="'+veilig(it.url)+'"><img src="'+veilig(img)+'" alt="'+nm+'"></a>'
        + '<div><a href="'+veilig(it.url)+'" style="font-size:14px">'+nm+'</a><div class="mini">'+((it.variant_title&&it.variant_title!=='Default Title')?('maat '+veilig(it.variant_title).replace('.',',')):'')+'</div>'
        + '<div style="display:inline-flex;border:1px solid var(--lijn-2);margin-top:8px"><button data-qty="'+(i+1)+'|'+(it.quantity-1)+'" aria-label="Eén minder" style="width:26px;height:26px;display:grid;place-items:center">&minus;</button><span style="width:30px;display:grid;place-items:center;font-size:12.5px">'+it.quantity+'</span><button data-qty="'+(i+1)+'|'+(it.quantity+1)+'" aria-label="Eén meer" style="width:26px;height:26px;display:grid;place-items:center">+</button></div></div>'
        + '<div style="text-align:right;display:flex;flex-direction:column;justify-content:space-between"><span class="prijs">'+geld(it.final_line_price)+'</span><button class="tlink" data-qty="'+(i+1)+'|0" style="font-size:9px">verwijder</button></div></div>';
      }).join('');
    voet.innerHTML='<div style="display:flex;justify-content:space-between;align-items:baseline"><span class="lbl zwart">subtotaal</span><span class="prijs" style="font-family:var(--display);font-size:1.35rem">'+geld(cart.total_price)+'</span></div>'
      +'<span class="mini">Verzendkosten reken je af in de volgende stap.</span>'
      +'<form action="/cart" method="post"><button class="btn vol" type="submit" name="checkout">afrekenen</button></form>'
      +'<a class="tlink" href="/cart" style="text-align:center">bekijk de mand</a>';
  }
  function haalMand(){ fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(tekenMand); }
  var mk=$('#mandknop'); if(mk) mk.onclick=function(){ open('#mand'); haalMand(); };
  document.addEventListener('click',function(e){
    var q=e.target.closest('[data-qty]'); if(!q) return;
    var d=q.getAttribute('data-qty').split('|');
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:+d[0],quantity:+d[1]})})
      .then(function(r){return r.json()}).then(tekenMand);
  });
  var pdpForm=$('#pdp-form');
  if(pdpForm){
    $$('[data-maat]').forEach(function(b){
      b.addEventListener('click',function(){
        if(b.classList.contains('op')) return;
        $$('[data-maat]').forEach(function(x){x.classList.remove('aan')});
        b.classList.add('aan');
        $('#variant-id').value=b.getAttribute('data-maat');
        var k=$('#koopknop'); k.disabled=false; k.textContent='in de winkelmand';
      });
    });
    pdpForm.addEventListener('submit',function(e){
      e.preventDefault();
      var id=$('#variant-id').value;
      if(!id){ toon('Kies eerst een maat'); var m=$('.maten-pdp'); if(m){ m.scrollIntoView({block:'center',behavior:'smooth'}); } return; }
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:+id,quantity:1}]})})
        .then(function(r){return r.json()}).then(function(){ open('#mand'); haalMand(); toon('Toegevoegd aan je mand'); });
    });
    $$('[data-thumb]').forEach(function(b){
      b.addEventListener('click',function(){
        $$('[data-thumb]').forEach(function(x){x.classList.remove('aan')});
        b.classList.add('aan');
        $('#hoofdbeeld img').src=b.getAttribute('data-groot');
      });
    });
  }
  var r=$('#roul');
  var regels = (r && r.getAttribute('data-regels')) ? r.getAttribute('data-regels').split('|') : [];
  var i=0;
  if(r && regels.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches){
    r.style.display='inline-block';
    r.style.transition='opacity .22s ease, transform .22s ease';
    setInterval(function(){
      i=(i+1)%regels.length;
      r.style.opacity=0; r.style.transform='translateY(-4px)';
      setTimeout(function(){
        r.textContent=regels[i];
        r.style.transform='translateY(4px)';
        requestAnimationFrame(function(){ r.style.opacity=1; r.style.transform='none'; });
      },230);
    },6500);
  }
  $$('[data-ct]').forEach(function(b){
    b.addEventListener('click',function(){
      var groep=b.getAttribute('data-ct-groep');
      $$('[data-ct-groep="'+groep+'"]').forEach(function(x){x.classList.remove('aan')});
      b.classList.add('aan');
      var kleur=$('[data-ct-groep="kleur"].aan'), model=$('[data-ct-groep="model"].aan'), leer=$('[data-ct-groep="leer"].aan');
      var el=$('#ct-samen');
      if(el) el.textContent=[model?model.getAttribute('data-ct'):'', leer?leer.getAttribute('data-ct'):'', kleur?kleur.getAttribute('data-ct'):''].filter(Boolean).join(' · ');
    });
  });
})();